// @flow

import React from 'react';
import bemify, { toModifiers } from 'bemify-js';
import { omit } from 'lodash';

import { Link } from '@zapier/design-system';

import 'web-ssr/app/common/components/Button.scss';

import type { Node } from 'react';

import type { DisplayTarget, KindType } from 'web-ssr/app/common/types';

const bem = bemify('button');

type Props = {
  children: Node,
  className?: string,
  href?: string,
  rel?: string,
  route?: string,
  disabled?: boolean,
  kind?: KindType,
  onClick?: (event: SyntheticEvent<HTMLAnchorElement>) => any,
  target?: DisplayTarget,
};

const LinkButton = (props: Props) => {
  const { children, kind, disabled, className } = props;

  if (disabled) {
    return (
      <div
        {...omit(props, ['children', 'kind'])}
        className={bem(className, toModifiers(kind))}
      >
        {children}
      </div>
    );
  }

  return (
    <Link
      {...omit(props, ['children', 'kind'])}
      className={bem(className, toModifiers(kind))}
    >
      {children}
    </Link>
  );
};

export default LinkButton;
